import React, { useState } from 'react'
import { FiPrinter } from 'react-icons/fi'
import PrintModal from '../../PrintModal'
import { Modals } from '../../../Modals/ModalContainer'
import Button from './Button'
import { PopoveredIcon2 } from '../../../../components/PopoveredIcon/PopoveredIcon'
import { useSelector } from 'react-redux'
import {
  getUserPriceGroup,
  isUserNewPremium,
} from '../../../../reducers/userAccount/selectors/userAccount'
import { isAllInOneLicenseValid } from '../../../../reducers/userAccount/selectors/license'

function Printer({
  className,
  isPremium,
  modalOpen,
  size = 1,
  modalClose,
}: IPrinterDispatch & IPrinterProps) {
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const userPriceGroup = useSelector(getUserPriceGroup)
  const isAllInOnePriceGroup = useSelector(isUserNewPremium)
  const isAllInOneUser = useSelector(isAllInOneLicenseValid)
  const isAllInOneFreeUser = !isAllInOneUser && isAllInOnePriceGroup

  function openPrintModal() {
    modalOpen(Modals.PrintModal, <PrintModal onClose={modalClose} />)
  }

  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  return (
    <>
      {(isPremium && userPriceGroup !== 3) || isAllInOneFreeUser ? (
        <Button
          size={size}
          className={`${className}-button-print`}
          outline={true}
          onClick={openPrintModal}
        >
          <FiPrinter size={16 * size} />
        </Button>
      ) : (
        <Button
          size={size}
          as={'a'}
          outline={true}
          className={`${className}-button-print`}
          onClick={handlePopoverOpen}
          style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          <FiPrinter size={16 * size} />
          <PopoveredIcon2
            anchorEl={popoverAnchor}
            onClose={handlePopoverClose}
          />
        </Button>
      )}
    </>
  )
}

export default Printer

export interface IPrinterProps {
  className: string
  size?: number
  isPremium: boolean
}

export interface IPrinterDispatch {
  modalClose: (id) => void
  modalOpen: (id, element) => void
}
